export default __webpack_public_path__ + "static/blog-img6-9ac7647614732cb012c81ece198f7aca.jpg";